import { useSelector } from 'react-redux';
import ManualExpenses from '../../../../components/Finance/ProvidersExpenses/ManualExpense/ManualExpenses'
import { CheckPermissions } from '../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions';
import { selectUserData } from '../../../../features/userSlice';
import Page404 from '../../../../components/Page404/Page403';

const FinanceManualExpenseScreen = () => {
  const userData = useSelector(selectUserData);
  const hasViewManualExpensePermission = CheckPermissions(
    userData?.data?.products?.finance,
    "providers_expenses",
    "view_manual_expenses"
  );
  return (
    <>
      {hasViewManualExpensePermission ? (
        <ManualExpenses />
      ) : (
        <Page404 />
      )}
    </>
  )
}

export default FinanceManualExpenseScreen
